(($, Drupal, once) => {
  const redirectToCountry = (select, otherCountryNodeId = null) => {
    let nodeId = select.value;
    if (!nodeId || nodeId === '_none') {
      return;
    }

    if (nodeId === 'other' && otherCountryNodeId) {
      nodeId = otherCountryNodeId;
    }

    const langcode = document.documentElement.lang;
    const path = langcode === 'en'
      ? `/node/${nodeId}`
      : `/${langcode}/node/${nodeId}`;

    window.location.assign(path);
  };

  const initializeJumpMenu = (
    select,
    jumpMenuSelector,
    otherCountryNodeId = null
  ) => {
    const bindRedirect = element => {
      element.options[0].disabled = true;
      $(element).on('change.onespanCountryJumpMenu', () => {
        redirectToCountry(element, otherCountryNodeId);
      });
    };

    bindRedirect(select);

    const jumpMenu = document.querySelector(jumpMenuSelector);
    if (!jumpMenu || jumpMenu.querySelector('select.select-country')) {
      return;
    }

    const clone = select.cloneNode(true);
    clone.removeAttribute('id');
    bindRedirect(clone);
    jumpMenu.appendChild(clone);

    if (typeof $.fn.selectpicker === 'function') {
      $(clone).selectpicker();
    }
  };

  Drupal.behaviors.onespanCountryJumpMenu = {
    attach(context) {
      once(
        'onespan-legality-country-jump-menu',
        '.legality-hero select.select-country',
        context
      ).forEach(select => {
        initializeJumpMenu(select, '.country-jump-menu', 115231);
      });

      once(
        'onespan-grr-country-jump-menu',
        '.grr-hero select.select-country',
        context
      ).forEach(select => {
        initializeJumpMenu(select, '.country-dropdown-menu');
      });
    }
  };
})(jQuery, Drupal, once);
